import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

import { SIMPLE_SURVEY_MAX_WIDTH } from '../../SimpleSurvey/styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;
  max-width: ${SIMPLE_SURVEY_MAX_WIDTH}px;

  ${QUERIES.largeTabletAndUp} {
    max-width: 800px;
  }

  align-items: center;
  box-sizing: border-box;
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-8);
  width: 100%;
`;

export const CreateFirstBody = styled.div`
  display: flex;
  flex-direction: column;

  gap: var(--spacing-8);
  width: 100%;
  ${QUERIES.largeTabletAndUp} {
    gap: var(--spacing-16);
  }
`;

export const HideMobile = styled.div`
  display: none;

  ${QUERIES.largeTabletAndUp} {
    display: block;
    width: 100%;
  }
`;

export const HideDesktop = styled.div`
  display: block;
  width: 100%;

  ${QUERIES.largeTabletAndUp} {
    display: none;
  }
`;
